import store from '@/store'
import network from '@/utils/network'
import { $ui } from '@/utils/ui'
import { MODAL_EVENT_UPDATE_SERVICES } from '@/consts/app'
import { STATUS_UNPROGRAMMED } from '@/consts/services'

/**
 * Map les servicesCheckpoints
 * @param checkpoints
 * @param s
 * @returns {{checkpoints: *}}
 */
const mapServiceCheckpoints = ({ checkpoints, ...s }) => ({
  ...s,
  checkpoints: s.id && checkpoints
    ? checkpoints.map(({ checkpoint, ...c }) => ({
      ...c,
      service: s.id,
      checkpoint: checkpoint.id
    }))
    : checkpoints
})

/**
 * Récupère les informations d'un circuit / service
 * @param reference
 * @returns {Promise}
 */
export const getCircuit = async (reference) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}/circuit/${reference}`)
  return r.data
}

/**
 * Récupère les rounds d'un site ou d'un circuit
 * @param id
 * @returns {Promise}
 */
export const getCircuitRounds = async ({ id }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.get(`agency/${slugAgency}/circuit/${id}/rounds`)
  return r.data
}

/**
 * Permet de créer un circuit
 * @param status
 * @param circuit
 * @returns {Promise}
 */
export const postCircuit = async ({ service: { status, ...service }, event }) => {
  const slugAgency = store.getters['user/agencySlug']
  const { data } = await network.post(`agency/${slugAgency}/circuit${status ? `/${status}` : ''}`, {
    service: mapServiceCheckpoints(service),
    event
  })
  // TODO a retirer lors de la mise en place du store planning
  $ui.$emit(MODAL_EVENT_UPDATE_SERVICES, [data.service])
  return data
}

/**
 * Permet de check les erreurs d'un circuit avant création
 * @param services
 * @returns {Promise}
 */
export const checkCircuits = async ({ services }) => {
  const slugAgency = store.getters['user/agencySlug']
  const { data } = await network.post(`agency/${slugAgency}/checkcircuits`, services)
  return data
}

/**
 * Permet de créer des circuits
 * @param services
 * @param status
 * @returns {Promise}
 */
export const postCircuits = async ({ services, status }) => {
  const slugAgency = store.getters['user/agencySlug']
  const { data } = await network.post(
    `agency/${slugAgency}/circuits${status ? `/${status}` : ''}`,
    services.map(mapServiceCheckpoints)
  )
  // TODO a retirer lors de la mise en place du store planning
  setTimeout(() => {
    $ui.$emit(
      MODAL_EVENT_UPDATE_SERVICES,
      data.services.map((s) => ({
        ...s,
        _deleted: s.status === STATUS_UNPROGRAMMED
      }))
    )
  }, 250) // Permet d'attendre que les modals soient fermées avant de notifier la MAJ (perfs)
  return data
}

/**
 * Permet de modifier le status d'un circuit (début, fin de service etc...)
 * @param status
 * @param circuit
 * @returns {Promise}
 */
export const patchCircuit = async ({ service: { status, ...service }, event }) => {
  const slugAgency = store.getters['user/agencySlug']
  const { data } = await network.patch(`agency/${slugAgency}/circuit${status ? `/${status}` : ''}`, { service, event })
  // TODO a retirer lors de la mise en place du store planning
  $ui.$emit(MODAL_EVENT_UPDATE_SERVICES, [data.service])
  return data
}

/**
 * Permet d'ajouter / modifier une pause dans un circuit
 * @param status
 * @param circuit
 * @param pause
 * @param event
 * @returns {Promise}
 */
export const putCircuitBreak = async ({ circuit, break: { status, ...pause }, event }) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.put(`agency/${slugAgency}/circuit/${circuit}/break${status ? '/' + status : ''}`, {
    break: pause,
    event
  })
  return r.data
}
